import React, { Component } from "react";
import {withNamespaces} from "react-i18next";

class LayoutRow extends Component {

    render() {

        const editClass = this.props.editMode ? "" : "";

        return (
            <div className={`row ${editClass} ${this.props.className} `}>
                { this.props.children }
            </div>
        );
    }
}
export default withNamespaces()(LayoutRow);
